import * as React from "react";
import classNames from "classnames";

interface IProps {
    height?: number;
    width?: number;
    className?: string;
    mainColor?: string;
    accentColor?: string;
}

export const CameraIcon = (props: IProps) => {
    return (
        <svg className={classNames(props.className, "svg-icon")} width={props.width || "17"} height={props.height || "15"} viewBox="0 0 17 15" fill="none">
            <circle cx="8.59615" cy="7.59615" r="3.59615" fill={props.mainColor || "#37474f"} />
            <path
                d="M15.5833 2.1577H13.3369C13.053 2.1577 12.7863 2.04533 12.5854 1.84163L11.2904 0.526781C10.956 0.18718 10.5112 0 10.038 0H6.96192C6.48877 0 6.04399 0.18718 5.70953 0.526781L4.41461 1.84163C4.21367 2.04533 3.94701 2.1577 3.66306 2.1577H1.41667C0.635341 2.1577 0 2.80281 0 3.59614V12.9461C0 13.7395 0.635341 14.3846 1.41667 14.3846H15.5833C16.3646 14.3846 17 13.7395 17 12.9461V3.59614C17 2.80281 16.3646 2.1577 15.5833 2.1577ZM8.49998 12.2269C6.15641 12.2269 4.24999 10.2912 4.24999 7.91153C4.24999 5.53189 6.15641 3.59614 8.49998 3.59614C10.8436 3.59614 12.75 5.53189 12.75 7.91153C12.75 10.2912 10.8436 12.2269 8.49998 12.2269ZM13.4583 5.03461C13.4583 5.43109 13.7762 5.75383 14.1666 5.75383C14.5571 5.75383 14.875 5.43109 14.875 5.03461C14.875 4.63814 14.5571 4.31539 14.1666 4.31539C13.7762 4.31539 13.4583 4.63814 13.4583 5.03461Z"
                fill={props.mainColor || "#37474f"}
            />
        </svg>
    );
};
